export const APP_LOADED = "[search] APP_LOADED";
export const UPDATE_QUERY = "[search] UPDATE_QUERY";
export const SEARCH_OPTION_SELECTED = "[search] SEARCH_OPTION_SELECTED";
export const REMOVE_FILTER = "[search] REMOVE_FILTER";
export const RESET_FILTER = "[search] RESET_FILTER";
export const RESET_FILTERS = "[search] RESET_FILTERS";
export const RESTORE_FILTERS = "[search] RESTORE_FILTERS";
export const REMOVE_FILTERS = "[search] REMOVE_FILTERS";
export const ADD_FILTER = "[search] ADD_FILTER";
export const UPDATE_FILTER = "[search] UPDATE_FILTER";
export const UPDATE_FILTERS = "[search] UPDATE_FILTERS";
export const UPDATE_SORT = "[search] UPDATE_SORT";
export const UPDATE_PAGE = "[search] UPDATE_PAGE";
export const RESET_PAGE = "[search] RESET_PAGE";
export const UPDATE_SETTINGS = "[search] UPDATE_SETTINGS";
export const UPDATE_SEARCH_RESULTS_PAGE = "[search] UPDATE_SEARCH_RESULTS_PAGE";

